module.exports = import("https://public.tableau.com/javascripts/api/tableau.embedding.3.latest.min.js");;